module.exports = __webpack_public_path__ + "static/media/video-play.12849fba.svg";